import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const MainSection = lazy(() => import('@/pages/mainSection'));
const TopBannerList = lazy(() => import('@/pages/mainSection/topBanner/TopBannerList'));
const PopupList = lazy(() => import('@/pages/mainSection/popup/PopupList'));
const PopupDetail = lazy(() => import('@/pages/mainSection/popup/PopupDetail'));

// 메인 섹션 라우트
export const mainSectionRoutes: TypedRouteObject = {
	path: ROOTS.MAIN_SECTION,
	element: withSuspense(MainSection),
	handle: {
		title: '메인섹션 관리',
		subTitle: '락앤런 메인페이지 컨텐츠 관리',
		permission: 'MAIN_SECTION' as const
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		{
			path: paths.mainSection.topBanner.list.path,
			element: withSuspense(TopBannerList),
			handle: {
				title: '메인 최상단 배너 노출 관리',
				subTitle: '메인섹션 > 최상단 배너 > 최상단 배너 목록'
			}
		},
		// 메인 팝업
		{
			path: paths.mainSection.popup.list.path,
			element: withSuspense(PopupList),
			handle: {
				title: '메인 팝업 노출 관리',
				subTitle: '메인섹션 > 메인 팝업 > 메인 팝업 목록'
			}
		},
		{
			path: paths.mainSection.popup.detail.path,
			element: withSuspense(PopupDetail),
			handle: {
				isGoBack: true,
				title: '메인팝업 상세정보',
				subTitle: '메인섹션 > 메인팝업 > 상세정보'
			}
		}
	]
};
